module.exports = __webpack_public_path__ + "static/car_product_2-0100045fa07afa037317b90f93d4cd95.jpg";